'use client';

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { isExpired } from "react-jwt";
import { getAccessToken, setAccessToken } from "@/lib/api/authTokens";
import { performTokenRefresh } from "@/lib/api/auth";

export function usePageAuth() {
  const router = useRouter();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = await getAccessToken();

      if (!token || isExpired(token)) {
        try {
          const refreshed = await performTokenRefresh();
          if (!refreshed) {
            router.replace("/");
            return;
          }
        } catch {
          router.replace("/");
          return;
        }
      }
      setIsChecking(false);
    };

    checkAuth();
  }, [router]);

  return { isChecking };
}